import { useTranslation } from 'react-i18next';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { type ImportedLocation } from 'api/location-importer.api';

interface DeleteNodeDialogProps {
  target: ImportedLocation | null;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteNodeDialog({
  target,
  deleting,
  onClose,
  onConfirm,
}: DeleteNodeDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog
      open={target !== null}
      onClose={() => {
        if (!deleting) onClose();
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 600 }}>
        {t('roads_importer_delete_title')}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('roads_importer_delete_confirm', { name: target?.name ?? '' })}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="outlined"
          size="small"
          disabled={deleting}
          onClick={onClose}
          sx={{ borderRadius: '8px', fontWeight: 600 }}
        >
          {t('roads_importer_btn_cancel')}
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          startIcon={
            deleting ? <CircularProgress size={14} /> : <DeleteOutlineIcon />
          }
          disabled={deleting}
          onClick={onConfirm}
          sx={{ borderRadius: '8px', fontWeight: 600 }}
        >
          {t('roads_importer_btn_delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
